import { zodResolver } from "@hookform/resolvers/zod";
import useTranslation from "next-translate/useTranslation";
import { useForm } from "react-hook-form";
import { TALK_ROOM_COMMENT_SCHEMA } from "~/models/talkRoom";

const useTalkRoomCommentForm = () => {
  const { t } = useTranslation();
  return useForm<{ message: string }>({
    defaultValues: { message: undefined },
    mode: "onChange",
    resolver: zodResolver(TALK_ROOM_COMMENT_SCHEMA(t)),
  });
};

export default useTalkRoomCommentForm;
